/** Brand glyphs in their own colours. Gradient ids are suffixed so multiple instances stay valid. */
let uid = 0;
const nextId = () => `vc-sg-${(uid += 1)}`;

export function InstagramGlyph({ size = 24, className = "" }) {
  const id = nextId();
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="2" y1="22" x2="22" y2="2" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FFC83D" />
          <stop offset="30%" stopColor="#F74E6E" />
          <stop offset="62%" stopColor="#D62976" />
          <stop offset="100%" stopColor="#7638FA" />
        </linearGradient>
      </defs>
      <rect x="2.6" y="2.6" width="18.8" height="18.8" rx="5.4" stroke={`url(#${id})`} strokeWidth="1.9" />
      <circle cx="12" cy="12" r="4.1" stroke={`url(#${id})`} strokeWidth="1.9" />
      <circle cx="17.3" cy="6.7" r="1.25" fill={`url(#${id})`} />
    </svg>
  );
}

export function TelegramGlyph({ size = 24, className = "" }) {
  const id = nextId();
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="12" y1="2" x2="12" y2="22" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#37BBFE" />
          <stop offset="100%" stopColor="#007DBB" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="10" fill={`url(#${id})`} />
      <path
        d="M6.9 11.9c2.9-1.26 4.83-2.09 5.8-2.49 2.76-1.15 3.33-1.35 3.71-1.36.08 0 .27.02.39.12.1.08.13.19.14.27.01.08.03.26.02.4-.16 1.63-.83 5.6-1.18 7.43-.15.78-.44 1.04-.72 1.06-.61.06-1.07-.4-1.66-.79-.92-.6-1.44-.98-2.34-1.57-1.04-.68-.37-1.05.23-1.66.15-.16 2.84-2.6 2.89-2.82.01-.03.01-.13-.05-.19-.06-.05-.15-.03-.21-.02-.09.02-1.57 1-4.43 2.93-.42.29-.8.43-1.14.42-.37-.01-1.09-.21-1.63-.39-.66-.21-1.18-.33-1.14-.69.03-.19.29-.39.78-.59Z"
        fill="#fff"
      />
    </svg>
  );
}
